import apiClient from '../apiClient';
import { GET_PAYMENT_SCHEME_BY_ID_URL } from '../apiUrl';

const getPaymentSchemeByIdApi = Id => {
  return apiClient.get(GET_PAYMENT_SCHEME_BY_ID_URL(Id));
};

export default getPaymentSchemeByIdApi;
